import { FeatureLabel3D } from './procedural/FeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from './procedural/SurfaceLineFeature3D'
import React from 'react'
import { GeckoComponentPath, GeckoGenericHeadRadialWeld } from 'types'

/**
 * A component used to render a single Radial weld on a component's surface
 * @param model             The asset model for this Radial weld
 * @constructor
 */
export const GenericHeadRadialWeldFeature3D: React.FC<{
  model: GeckoGenericHeadRadialWeld
}> = ({ model }) => {
  const path = React.useMemo(() => {
    return GeckoComponentPath.CreateFromVerticalLine(model.feature_geometry)
  }, [model.feature_geometry])

  return (
    <group name={model.id}>
      <SurfaceLineFeature3D
        path={path}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <FeatureLabel3D
        feature={model}
        coords={model.feature_geometry.end}
        anchor={'top left'}
        showBoundaryLabelIn2D
      />
    </group>
  )
}
